import React from 'react'

const RoomDataLoader = () => {
    return (
        <div className="loader__for__model"></div>
    )
}

export default RoomDataLoader;